import React from "react";
import Box from "@mui/joy/Box";
import Tabs from "@mui/joy/Tabs";
import TabList from "@mui/joy/TabList";
import Tab from "@mui/joy/Tab";
import PersonIcon from "@mui/icons-material/Person";
import GroupIcon from "@mui/icons-material/Group";

interface RoleTabsProps {
  role: "owner" | "cc";
  onRoleChange: (role: "owner" | "cc") => void;
  size?: "sm" | "md" | "lg";
}

export const RoleTabs: React.FC<RoleTabsProps> = ({ role, onRoleChange, size = "md" }) => {
  return (
    <Box
      sx={{
        mb: 2,
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <Tabs
        value={role}
        onChange={(_event, newValue) => onRoleChange(newValue as "owner" | "cc")}
        size={size}
        sx={{
          backgroundColor: "transparent",
        }}
      >
        <TabList
          disableUnderline
          sx={{
            p: 0,
            gap: 1,
            [`& .MuiTab-root`]: {
              py: 1.5,
              px: 3,
              fontSize: size === "sm" ? "0.875rem" : "1rem",
              fontWeight: 500,
              transition: "all 0.2s ease",
              borderRadius: "8px 8px 0 0",
              border: "none",
              borderBottom: "3px solid transparent",
              "&:hover": {
                backgroundColor: "var(--joy-palette-background-level1)",
              },
              "&.Mui-selected": {
                backgroundColor: "transparent",
                borderBottomColor: "primary.500",
                fontWeight: 600,
              },
            },
          }}
        >
          <Tab value="owner">
            <PersonIcon sx={{ mr: 1, fontSize: "1.2rem" }} />
            My Tickets
          </Tab>
          <Tab value="cc">
            <GroupIcon sx={{ mr: 1, fontSize: "1.2rem" }} />
            CC'd Tickets
          </Tab>
        </TabList>
      </Tabs>
    </Box>
  );
};
